export default "/images/registerbg.png?a75fc5f122249e03129dd11a6d012ba8";